import axios from 'axios'

// var callback;

var http = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {'Content-Type': 'application/json'},
})

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
    {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig()
{
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}

function getAllBlock(params, callback)
{
  var config = getConfig()
  // if(params) config.params = params[0]
  var url = '/lms/block_package/' + params
  http.get(url, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getListPackage(callback, params)
{
  var config = getConfig()
  // if(params) config.params = params[0]
  var url = '/lms/block_packages'
  http.get(url, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getListBimbel(callback, params)
{
  var config = getConfig()
  // if(params) config.params = params[0]
  var url = '/lms/packages'
  http.get(url, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function addBimbel(dataBody, callback)
{
  var config = getConfig()

  http.post('/lms/package', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function editBimbel(dataBody, callback)
{
  var config = getConfig()

  http.put('/lms/package/'+ dataBody[1], dataBody[0], config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function getListKurikulum(callback)
{
  var config = getConfig()
  http.get('/lms/curriculums', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}
function deleteBimbel (id, callback)
{
  var config = getConfig()
  http.delete('/lms/package/' + id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

function getbimbelDetailById (id, callback)
{
  var config = getConfig()
  http.get('/lms/package/' + id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

function publishBimbel(id, callback)
{
  var config = getConfig()
  http.put('/lms/package/'+ id +'/publish', '', config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}


function statPublishedBimbel(grade, callback)
{
  var config = getConfig()
  http.get('/lms/packages/?status=PUBLISHED&grade='+ grade, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}
//paket mapel

function addMapelPackage (dataBody, callback)
{
  var config = getConfig()

  http.post('/lms/block_package', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function deleteMapelPackage (id, callback)
{
  var config = getConfig()
  http.delete('/lms/block_package/' + id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

function publishMapel (id, callback)
{
  var config = getConfig()
  http.put('/lms/block_package/'+ id +'/publish', '', config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

function getMapelDetailById (id, callback)
{
  var config = getConfig()
  http.get('/lms/block_package/' + id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

function editMapelPackage(dataBody, callback)
{
  var config = getConfig()

  http.put('/lms/block_package/'+ dataBody[1], dataBody[0], config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function initializeBlockPackage(dataBody, callback)
{
  var config = getConfig();
  http.post('/lms/init_package', dataBody, config)
    .then(function(response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

export default
{
  getAllBlock,
  getListPackage,
  getListBimbel,
  getListKurikulum,
  addBimbel,
  deleteBimbel,
  getbimbelDetailById,
  editBimbel,
  publishBimbel,
  statPublishedBimbel,

  //paket mapel
  addMapelPackage,
  deleteMapelPackage,
  publishMapel,
  getMapelDetailById,
  editMapelPackage,
  initializeBlockPackage
}



// WEBPACK FOOTER //
// ./src/services/bimbel.js